import SupportOpened from './SupportOpened.vue';

export { SupportOpened };
export default SupportOpened;
